import { SetState } from 'zustand';
import { MeterRegister } from '@enmon/commons';
import type { InstallMeterStore } from '../../useStore';

const INITIAL_STATE: SensorScanForm = {
  dataSourceId: '',
};

export interface SensorScanForm {
  dataSourceId: Exclude<MeterRegister['dataSourceId'], null>;
}

export type SensorScanStepSlice = SensorScanForm & {
  resetSensorScanStepSlice: (initValues?: Partial<SensorScanForm>) => void;
  setSensorScanStepValues: (values: SensorScanForm) => void;
};

export const createSensorScanStepSlice = (set: SetState<InstallMeterStore>): SensorScanStepSlice => ({
  ...INITIAL_STATE,
  resetSensorScanStepSlice: (initValues = {}) => set({ ...INITIAL_STATE, ...initValues }),
  setSensorScanStepValues: (values: SensorScanForm) => set(values),
});
